/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host .container {
  padding-right: 1.1428571429rem;
}
:host .container davinci-icon-ref:last-child {
  display: none;
}

:host([hidden]) {
  display: none;
}`;
export { style };
